import { render } from "./App.vue?vue&type=template&id=27675d9f"
const script = {}

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/academy/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__